import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';
import RichText from '../atoms/richtext';
import { media } from '../../utils/media-queries';
import NumberValue from '../atoms/numberValue';
import { CtaLink, CtaPage } from '../atoms/cta';
import Accordion from '../molecules/accordion';
import Value from '../atoms/value';
import { ease } from '../../utils/easing';
import ImageGallery from '../molecules/imageGallery';
import Team from '../organisms/team';
import History from '../organisms/history';
import InterviewSection from '../organisms/interviewSection';
import VideoVimeo from '../organisms/videoVimeo';
import ValuesWrapper from '../molecules/valuesWrapper';
import { Radio } from '../atoms/radio';
import { LayoutContext } from '../organisms/layoutProvider';
import { Publication } from '../atoms/publication';

const Section = ({ headline, last = false, content }) => {

  console.log('content',content);
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const valueItem = {
    hidden: { opacity: 0, y: 0 },
    show: {
      opacity: 1,
      y: -10,
      transition: {
        duration: 0.3,
        ease: ease.outSnap,
      },
    },
  };

  const [clickedAcc, setClickedAcc] = useState(null);

  const handleClick = (i) => {
    if (clickedAcc === i) {
      setClickedAcc(null);
      return;
    }
    setClickedAcc(i);
  };

  const { teamHeight } = useContext(LayoutContext);

  const [activeTeam, setActiveTeam] = useState(0);

  return (
    <StyledSection className="grid">
      <h2>{headline}</h2>
      {content.map(
        (item, i) =>
          /**
           * Copy Module
           */
          (item?.__typename === 'SanityCopy' && (
            <div key={`copy-${i}`} className="copy content">
              <RichText blocks={item._rawCopy} />
            </div>
          )) ||
          /**
           * Numbers Module
           */
          (item?.__typename === 'SanityNumbers' && (
            <div key={`numbers-${i}`} className="numbers content">
              {item.number.map((number, numberI) => (
                <NumberValue
                  key={numberI}
                  value={number.value}
                  unit={number.unit}
                  description={number.description}
                />
              ))}
            </div>
          )) ||
          /**
           * Image Gallery Module
           */
          (item?.__typename === 'SanityImageGallery' && (
            <ImageGallery item={item} i={i} />
          )) ||
          /**
           * Main Image Module
           */

          (item?.__typename === 'SanityMainImage' && (
            <div className="img" key={`img-${i}`}>
              <p className="caption">{item.image.caption}</p>
              {/* {item.image.asset.gatsbyImageData.width}
              {item.image.asset.gatsbyImageData.height} */}
              <figure>
                {/* <GatsbyImage
                  layout="constrained"
                  image={item.image.asset.gatsbyImageData}
                  alt={item.image.alt}
                  width={item.image.asset.gatsbyImageData.width}
                  height={item.image.asset.gatsbyImageData.height}
                /> */}

                <div className="image-wrapper">
                  <img
                    src={item.image.asset.gatsbyImageData.images.fallback.src}
                    sizes={
                      item.image.asset.gatsbyImageData.images.fallback.sizes
                    }
                    srcSet={
                      item.image.asset.gatsbyImageData.images.fallback.srcSet
                    }
                    alt={item.caption && item.caption}
                  />
                </div>
                {item.caption &&
                  <figcaption>
                    <span className="dot" />
                    {item.caption}
                  </figcaption>
                }
              </figure>
            </div>
          )) ||
          /**
           * Cta Module
           */
          (item?.__typename === 'SanityCta' &&
            ((item.link[0].__typename === 'SanityLinkPage' && (
              <div className="content" key={`cta-${i}`}>
                <CtaPage title={item.title} to={item.link[0].page} />
              </div>
            )) ||
              (item.link[0].__typename === 'SanityLinkUrl' && (
                <div className="content" key={`cta-${i}`}>
                  <CtaLink title={item.title} href={item.link[0].url} />
                </div>
              )))) ||
          /**
           * Publication Module
           */
          (item?.__typename === 'SanityPublications' && (
            <div className="content" key={`publications-${i}`}>
              {item.publication.map((publication) => (
                <Publication
                  subline={publication.subline}
                  title={publication.headline}
                  href={publication.url}
                />
              ))}
            </div>
          )) ||
          /**
           * Accordion Module
           */
          (item?.__typename === 'SanityAccordion' && (
            <div className="accordion content" key={`accordion-${i}`}>
              {item.accordion.map((accordion, accordionI) => (
                <Accordion
                  key={accordionI}
                  light
                  headline={accordion.headline}
                  onClick={() => handleClick(accordionI)}
                  active={clickedAcc === accordionI}
                >
                  {accordion.description}
                </Accordion>
              ))}
            </div>
          )) ||
          /**
           * Values Module
           */
          (item?.__typename === 'SanityValues' && (
            <ValuesWrapper key={`values-${i}`} variants={container}>
              {item.values.map((value, valueI) => (
                <Value
                  variants={valueItem}
                  headline={value.headline}
                  description={value.description}
                  number={valueI + 1}
                />
              ))}
            </ValuesWrapper>
          )) ||
          /**
           * Team Module
           */
          (item?.__typename === 'SanityTeam' && (
            <>
              <div className="radios">
                {item.team.map((teamfilter, teamfilterI) => (
                  <Radio
                    key={`teamfilter-${teamfilterI}`}
                    title={teamfilter.headline}
                    active={teamfilterI === activeTeam}
                    onClick={() => setActiveTeam(teamfilterI)}
                  />
                ))}
              </div>
              <div
                key={`team-${i}`}
                className="team-wrapper"
                style={{ height: teamHeight }}
              >
                {item.team.map((team, teamI) => (
                  <Team
                    key={teamI}
                    dark={teamI === 2 ? 'dark' : ''}
                    headline={team.headline}
                    members={team.teamMembers}
                    className={`team-${teamI + 1}`}
                    style={{
                      background: teamI === 1 && 'var(--red-mid)',
                    }}
                    zIndex={teamI === activeTeam ? 3 : 1}
                    inactive={teamI !== activeTeam}
                    onClick={() => setActiveTeam(teamI)}
                  />
                ))}
              </div>
            </>
          )) ||
          /**
           * History Module
           */
          (item?.__typename === 'SanityHistory' && (
            <History key={`history-${i}`} timeline={item.timeline} />
          )) ||
          /**
           * Interviews Module
           */
          (item?.__typename === 'SanityInterviews' && (
            <InterviewSection key={`interviews-${i}`} interviews={item.items} />
          )) ||

          /**
          * Video Module
          */
          (item?.__typename === 'SanityVideo' && (
            <VideoVimeo url={item.url} />
          ))
      )}
      {/* {!last && <div className="divide" />} */}
    </StyledSection>
  );
};

const StyledSection = styled.section`
  padding-top: 2.4rem;
  padding-bottom: 4.0rem;
  padding-left: var(--sp-1-8);
  padding-right: var(--sp-1-8);
  overflow:hidden;
  border-bottom:1px solid rgba(0, 0, 0, 0.1);

  &:last-child {
    border-bottom:none;
  }

  .divide {
    height: 1px;
    background: rgba(0, 0, 0, 0.1);
    margin-top: var(--sp-3);
    // margin-bottom: var(--sp-3);
    margin-left: calc(var(--sp-1-8) * -1);
    margin-right: calc(var(--sp-1-8) * -1);
  }

  h2 {
    font-size: var(--fs-subhl);
    font-weight: 300;
  }

  .image-wrapper {
    width: 100%;
    height: auto;
    

    img {
      width: 100%;
      height auto;
    }
  }

  .img {
    padding: var(--sp-1-3) 0;
    position: relative;

    // .gatsby-image-wrapper {
    //   object-fit: cover;
    //   width: 100%;
    //   // height: calc(90vw / 16 * 9);
    // }

    .dot {
      background: var(--red);
      display: inline-block;
      width: 6px;
      height: 6px;
      position: absolute;
      left: 0;
      border-radius: 50%;
      transform: translateY(5px);
    }

    figcaption {
      padding-top: var(--sp-1-3);
      color: var(--red);
      font-size: var(--fs-small);
      width: 100%;
      padding-left: var(--sp-3);
      text-align: right;
    }
  }

  .numbers {
    display: flex;
    flex-wrap: wrap;
  }

  .team-wrapper {
    padding-top: var(--sp-3-8);
    margin-left: calc(var(--sp-1-8) * -1);
  }

  @media ${media.M} {
    padding-top: 13.0rem;
    padding-bottom: 13.0rem;
    padding-right: 0;
    padding-left: 0;

    &:last-child {
      padding-bottom:0rem;
    }

    h2 {
      grid-column: 2 / 6;
    }

    .content,
    .radios {
      grid-column: 6 / 12;
    }

    .img {
      grid-column: 2 / 12;

      figcaption {
        text-align: left;
        padding-left: 8vw;
        width: 29vw;
      }
    }

    .divide {
      margin-top: var(--sp-13);
      margin-bottom: var(--sp-8);
      margin-left: 0;
      margin-right: calc(var(--sp-1-8) * -1);
    }
  }

  @media ${media.XL} {
    .content {
      grid-column: 6 / 10;
    }
  }
`;

Section.propTypes = {
  headline: PropTypes.string,
  last: PropTypes.bool,
  content: PropTypes.array,
};

export default Section;
